import { Protocol } from '../Protocol';

export class ClearExecutionProtocol {
  public static readonly POST_CLEARANCE: string = `${Protocol.YATUNG_API_ROOT}/clearance`;
  public static readonly GET_PAGINATION_CLEARANCE: string = `${Protocol.YATUNG_API_ROOT}/clearance/p/all`;
}
